import { QueryClient } from '@tanstack/react-query';
import { QueryKeys } from 'api/models/QueryKeys';

export const invalidateQueryKeys = ({
  queryClient,
  queryKeys,
}: {
  queryClient: QueryClient;
  queryKeys: QueryKeys[];
}) => {
  return Promise.all(queryKeys.map(key => queryClient.invalidateQueries({ queryKey: [key] })));
};
